<template>
	<div>
		<div class="row">
			<div class="col-lg-12">
				<h1 class="page-header">Verstorbene</h1>
			</div>
		</div>

		<graveyard-select></graveyard-select>

		<custom-table edit="/deceaseds/{:id}" add="/deceaseds/new" :src-model="$store.getters.models('deceaseds')" :cols="cols" :criteria="criteria" store="deceaseds" search :default-sort="defSort"></custom-table>
	</div>
</template>

<script>
import CustomTable from 'components/custom-table.vue'
import GraveyardSelect from 'components/graveyard-select.vue'

import store from 'root/store.js'
import { authCheck, getRoutes } from 'functions/auth_check.js'

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('deceaseds')
		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	data () {
		return {
			criteria: [
				{ 'name': 'Vorname', 'json': 'firstname' },
				{ 'name': 'Nachname', 'json': 'lastname' },
				{ 'name': 'Geburtstag', 'json': 'birthday' },
				{ 'name': 'Todestag', 'json': 'dyingday', 'type': 'date' },
				{ 'name': 'Grab', 'json': 'grave_name', 'type': 'text' },
				{ 'name': 'Urnennummer', 'json': 'urn_number', 'type': 'text' }
			],

			cols: [
				{ 'name': 'Vorname', 'json': 'firstname', 'type': 'text' },
				{ 'name': 'Nachname', 'json': 'lastname', 'type': 'text' },
				{ 'name': 'Geburtstag', 'json': 'birthday', 'type': 'date' },
				{ 'name': 'Todestag', 'json': 'dyingday', 'type': 'date', 'colCSS': 'hidden-xs' },
				{ 'name': 'Grab', 'json': 'grave_name', 'type': 'text', 'colCSS': 'hidden-xs' }
			],

			defSort: { 'col': 'id', 'order': 'asc' }
		}
	},
	components: {
		'graveyard-select': GraveyardSelect,
		'custom-table': CustomTable
	},
	activated () {
		this.$store.dispatch('loadModel', 'deceaseds')
		.then(response => {
			//
		})
	}
}
</script>



// WEBPACK FOOTER //
// DeceasedOverview.vue?5dab8669